import { writeFile } from "node:fs/promises";
import { join } from "node:path";
import type { MemoryStore } from "./store.js";

export interface WriteMemoryIndexOptions {
  /** Top-level heading. Defaults to "Memory Index". */
  title?: string;
  /** Optional text placed above the heading (e.g. an HTML comment). */
  preamble?: string;
}

/**
 * Render a `MEMORY.md` index from the entries currently in `store` and
 * write it to `<store.dir>/MEMORY.md`. Existing `MEMORY.md` is overwritten.
 *
 * The index is a flat bullet list: one line per memory, linking to the
 * memory file and including the memory's `description`.
 */
export async function writeMemoryIndex(
  store: MemoryStore,
  options: WriteMemoryIndexOptions = {},
): Promise<void> {
  const ids = await store.list();
  const lines: string[] = [];
  if (options.preamble) {
    lines.push(options.preamble, "");
  }
  lines.push(`# ${options.title ?? "Memory Index"}`, "");
  for (const id of ids) {
    const memory = await store.read(id);
    lines.push(
      `- [${memory.frontmatter.name}](${id}.md) — ${memory.frontmatter.description}`,
    );
  }
  await writeFile(join(store.dir, "MEMORY.md"), `${lines.join("\n")}\n`, "utf8");
}
